import { Copy, Share2 } from "lucide-react";
import { Button } from "../button";
import { toast } from "react-toastify";
import { Product } from "@/lib/models/product";

interface SharedFormProps {
  product: Partial<Product> & { name: string; id?: string | number };
}

export default function SharedForm({ product }: SharedFormProps) {
  const datosCompartir = {
    title: product.name,
    text: "Mira este producto que encontré en Adises",
    url: `${typeof window !== "undefined" ? window.location.origin : ""}/producto/${product?.id}`,
  };
  const handleShare = async () => {
    // Verificamos si el navegador del usuario soporta la Web Share API
    if (navigator.share) {
      try {
        await navigator.share(datosCompartir);
        console.log("¡Compartido con éxito!");
      } catch (error) {
        // Captura si el usuario cierra la ventana sin compartir
        console.log("Error al compartir o el usuario canceló:", error);
      }
    } else {
      // Alternativa (Fallback) si el navegador no lo soporta (ej. navegadores web antiguos en PC)
      toast.warning("Tu navegador no soporta la función nativa de compartir.");
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(datosCompartir.url);
      toast.success("Enlace copiado al portapapeles.");
    } catch (err) {
      console.log("Error al copiar al portapapeles:", err);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Button onClick={handleShare} variant="ghost">
        <Share2 /> Compartir
      </Button>
      <Button onClick={handleCopy} variant="ghost">
        <Copy />
        Copiar link
      </Button>
    </div>
  );
}
